export enum CheckoutFailureCode {
  OOS = 'oos',
  BAD_ADDRESS = 'badAddress',
  SERVER_ERROR = 'serverError',
  REGISTRY_ERROR = 'registryError'
}
